module.exports = __webpack_public_path__ + "media/roxe.cdae6719.mp4";